/* eslint-disable no-restricted-properties */
Number.isInteger = Number.isInteger || (value => typeof value === 'number'
  && window.isFinite(value)
  && Math.floor(value) === value);



// WEBPACK FOOTER //
// ./app/javascript/lib/is_integer_polyfill.js